import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "tw-p-4 sm:tw-p-6" }
const _hoisted_2 = {
  key: 0,
  class: "tw-py-8 tw-text-center tw-text-sm tw-text-slate-500"
}
const _hoisted_3 = {
  key: 1,
  class: "tw-max-w-2xl tw-space-y-4"
}
const _hoisted_4 = { class: "tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-3" }
const _hoisted_5 = { class: "tw-rounded-xl tw-border tw-border-slate-200 tw-bg-slate-50 tw-px-3 tw-py-2 tw-text-sm tw-text-slate-600" }
const _hoisted_6 = { class: "tw-mt-5 tw-flex tw-justify-end tw-gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputField = _resolveComponent("InputField")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "tw-mb-4 tw-text-left" }, [
      _createElementVNode("h3", { class: "tw-text-lg tw-font-semibold tw-text-slate-900" }, "Account"),
      _createElementVNode("div", { class: "tw-mt-1 tw-text-sm tw-text-slate-600" }, "Update your name and password.")
    ], -1)),
    (_ctx.userLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Loading… "))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_InputField, {
              modelValue: _ctx.form.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
              label: "Name",
              autocomplete: "name"
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", null, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "tw-block tw-mb-1 tw-text-xs tw-font-medium tw-uppercase tw-tracking-wide tw-text-slate-500" }, " Email ", -1)),
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.form.email || '—'), 1)
            ]),
            _createVNode(_component_InputField, {
              modelValue: _ctx.form.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.password) = $event)),
              label: "New password",
              autocomplete: "new-password",
              placeholder: "Leave blank to keep current password"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_Button, {
              isGreen: true,
              icon: "check",
              enableLoading: _ctx.isSaving,
              disabled: _ctx.isSaving,
              onClick: _ctx.saveProfile
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode(" Save ", -1)
              ]))]),
              _: 1
            }, 8, ["enableLoading", "disabled", "onClick"]),
            _createVNode(_component_Button, {
              isRed: true,
              isSecondary: true,
              disabled: _ctx.isSaving,
              onClick: _ctx.resetForm
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode(" Cancel ", -1)
              ]))]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ])
        ]))
  ]))
}